import { useContext } from "react";
import { AuthContext } from "@shared/context/AuthContext";

interface ProtectedFetchGateState {
  shouldBlockProtectedFetch: boolean;
  authLoading: boolean;
  isAuthenticated: boolean;
  passwordChangeRequired: boolean;
}

/**
 * Central gate for protected API reads.
 * Blocks fetches while auth is resolving or when the user is unauthenticated.
 */
export function useProtectedFetchGate(): ProtectedFetchGateState {
  const auth = useContext(AuthContext);
  const authLoading = auth?.loading ?? false;
  const isAuthenticated = auth?.isAuthenticated ?? true;
  const passwordChangeRequired = false;

  return {
    shouldBlockProtectedFetch:
      authLoading || !isAuthenticated || passwordChangeRequired,
    authLoading,
    isAuthenticated,
    passwordChangeRequired,
  };
}

